const _sfc_main = {
  name: "CircleWarningFilled"
};
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  fill: "currentColor",
  d: "M512 34.13333333q202.68373333 5.3248 337.6128 140.25386667T989.86666667 512q-5.3248 202.68373333-140.25386667 337.6128T512 989.86666667q-202.68373333-5.3248-337.6128-140.25386667T34.13333333 512q5.3248-202.68373333 140.25386667-337.6128T512 34.13333333z m0 204.8q-27.7504 0-45.8752 20.2752T450.11626667 307.2l24.54186666 273.06666667q2.1504 14.9504 12.25386667 23.99573333t25.05386667 9.07946667 25.05386666-9.07946667 12.25386667-23.99573333l24.54186667-273.06666667q2.1504-27.7504-16.00853334-47.99146667T511.93173333 238.93333333z m0 546.13333334q23.48373333-1.05813333 38.94613333-16.00853334t15.4624-38.4-15.4624-38.94613333T512 676.2496t-38.94613333 15.4624-15.4624 38.94613333 15.4624 38.4T512 785.06666667z"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "circle-warning-filled.vue"]]);
